var gql = require("@apollo/client").gql;

const SPECIFICATIONS_QUERY = gql`
	query Specs {
		specifications {
			data {
				id
				name
				description
				image
				order
			}
		}
	}
`;

export default SPECIFICATIONS_QUERY;
